var _path, _path2, _ellipse, _ellipse2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 145,
    viewBox: "0 0 203 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.83 44.7202C168.751 40.7154 171.744 38.1564 175.475 40.7733C178.087 42.6056 176.694 46.3693 176.694 46.3693",
    stroke: "#FF9800",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.325 36.6205C160.063 30.2511 164.632 26.3389 169.185 27.4176C173.739 28.4962 173.303 32.7801 173.303 32.7801",
    stroke: "#FF9800",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 19.4715,
    cy: 7.54133,
    rx: 19.4715,
    ry: 7.54133,
    transform: "matrix(0.995469 0.0950859 -0.0890457 0.996028 152.482 57.2502)",
    fill: "#9077F6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 18.8968,
    cy: 10.0806,
    rx: 18.8968,
    ry: 10.0806,
    transform: "matrix(0.534164 0.845381 -0.871363 0.490639 123.762 19.7695)",
    fill: "#9077F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_732_43)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.707 36.7065C151.462 32.6219 143.84 33.4116 139.683 38.4703L124.248 57.252C120.603 61.6866 120.831 67.9297 124.476 72.1543L120.717 82.557L130.098 76.8303L133.129 79.1906C138.374 83.2752 145.996 82.4855 150.153 77.4268L165.588 58.6451C169.746 53.5864 168.864 46.1743 163.619 42.0897L156.707 36.7065Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.645 44.5064C149.205 45.0413 149.182 45.9001 149.875 46.44C150.429 46.872 151.285 46.661 151.615 46.2598L152.604 45.0562C153.153 44.3876 153.067 43.6624 152.512 43.2305C151.819 42.6906 151.073 42.7679 150.524 43.4365L149.645 44.5064ZM151.901 52.5069C151.476 52.1759 150.839 52.2382 150.648 52.7295C150.182 53.9235 150.541 55.311 151.638 56.1652C152.735 57.0194 154.204 57.0556 155.298 56.3513C155.749 56.0616 155.672 55.4432 155.246 55.1122L151.901 52.5069ZM161.8 55.7248C161.246 55.2929 161.269 54.434 161.709 53.8991L162.588 52.8293C163.138 52.1606 163.883 52.0834 164.438 52.5153C164.993 52.9472 165.217 53.7803 164.668 54.4489L163.679 55.6525C163.349 56.0537 162.355 56.1567 161.8 55.7248ZM136.255 52.7787C135.779 52.4078 135.087 52.4795 134.71 52.9388C134.332 53.398 134.412 54.0709 134.888 54.4417L151.269 67.1987C151.745 67.5695 152.437 67.4978 152.815 67.0385C153.192 66.5793 153.112 65.9064 152.636 65.5356L136.255 52.7787ZM132.838 56.9364C132.362 56.5656 131.67 56.6372 131.292 57.0965C130.915 57.5557 130.995 58.2286 131.471 58.5995L147.852 71.3564C148.328 71.7272 149.02 71.6555 149.397 71.1962C149.775 70.737 149.695 70.0641 149.219 69.6933L132.838 56.9364ZM127.876 61.2542C128.253 60.7949 128.945 60.7232 129.421 61.094L136.318 66.4654C136.794 66.8362 136.874 67.5091 136.497 67.9683C136.12 68.4276 135.428 68.4993 134.952 68.1285L128.054 62.7571C127.578 62.3863 127.498 61.7134 127.876 61.2542Z",
    fill: "#1A2E58"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.707 82.6361C111.563 80.662 101.239 78.5339 93.0996 85.8137C82.9253 94.9134 83.8782 106.571 65.7279 102.368C47.5776 98.1661 35.1444 92.2439 25.5197 101.715C15.895 111.186 31.4288 127.718 39.3176 121.112C54.2672 108.591 10.8092 102.586 1.56989 109.526",
    stroke: "#BBC2FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_732_43",
    x: 86.7168,
    y: 0.0930061,
    width: 115.494,
    height: 116.464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.34902 0 0 0 0 0.596078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_732_43"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_732_43",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBee);
export default __webpack_public_path__ + "static/media/bee.f1a45d83fe3de6aa9e3c543cc64520b2.svg";
export { ForwardRef as ReactComponent };